import React from "react";
import { Select, Descriptions, Tag } from "antd";
import { RentableAreaStoreModel } from "store/models/master-data/rentable-area";
import SearchHelp from "Components/search-help";
import { RENTABLE_AREA_POSITIONS } from "Constants";

export default function RentableAreaSelect({
  form,
  field,
  params,
  defaultValue,
  objectInValue,
}) {
  return (
    <SearchHelp
      objectInValue={objectInValue}
      form={form}
      field={field}
      defaultValue={defaultValue}
      model={RentableAreaStoreModel}
      allowClear={true}
      params={params}
      style={{ width: "100%" }}
      searchParam="fastSearchParam"
      placeholder="Kiralanabilir Alan Seçiniz"
      optionTemplate={(item) => {
        return (
          <Select.Option
            key={item.id}
            value={item.id}
            disabled={item.position === "FULL"}
          >
            <Descriptions column={{ xs: 1, sm: 1, md: 1, lg: 1 }}>
              <Descriptions.Item label="">
                {item.description}&nbsp;
                <Tag color={item.position === "FULL" ? "blue" : "green"}>
                  {RENTABLE_AREA_POSITIONS[item.position]}
                </Tag>
              </Descriptions.Item>
              <Descriptions.Item label="Birim/Alt Birim" span={2}>
                {item.subUnit?.unit?.description} / {item.subUnit?.description}
              </Descriptions.Item>
              <Descriptions.Item label="Adres">
                {item.address}
              </Descriptions.Item>
              <Descriptions.Item label="Tür">
                {item.rentableAreaType.description}
              </Descriptions.Item>
            </Descriptions>
          </Select.Option>
        );
      }}
    />
  );
}
